import {
  ARtoCaseStepperConfig,
  ARtoReferralStepperConfig,
  contactsStepperConfig,
  intakesStepperConfig,
  screeningsStepperConfig,
  screeningToreferralStepperConfig,
  facesheetReferralStepperConfig,
  referralsStepperConfig,
  draftOrgStepperConfig,
} from '../config';

const configDictionary = {
  'assistance-requests/contacts': ARtoCaseStepperConfig,
  'assistance-requests/referrals': ARtoReferralStepperConfig,
  contacts: contactsStepperConfig,
  intakes: intakesStepperConfig,
  referrals: referralsStepperConfig,
  screenings: screeningsStepperConfig,
  'screenings/referral': screeningToreferralStepperConfig,
  'facesheet-referral': facesheetReferralStepperConfig,
  organization: draftOrgStepperConfig,
};

function getStepperConfig(context) {
  return configDictionary[context];
}

export default getStepperConfig;
